import $ from 'jquery';
import Auth from '../auth/Auth';
import {Globs} from '../Globs';

import Entrance from '../pages/Entrance';
//import {CommonHelper, SCHError} from '../index';
//
import CommonHelper from '../helpers/CommonHelper';
import SCHError from '../helpers/SCHError';


import Config from '../Config';


const baseURL = Config.apiURL;



const RestClient = {

  disableNonEnterQueries(){
    //console.log('disableNonEnterQueries');
    localStorage.setItem('nonenter_queries_allowed', '0');
  },

  enableNonEnterQueries(){
    //console.log('enableNonEnterQueries');
    localStorage.setItem('nonenter_queries_allowed', '1');
  },

  allowedNonEnterQueries(){
    // console.log('allowedNonEnterQueries 0');
    // console.log(localStorage.getItem('nonenter_queries_allowed'));
    // console.log((localStorage.getItem('nonenter_queries_allowed') === '1'));
    // console.log('allowedNonEnterQueries 1');

    return (localStorage.getItem('nonenter_queries_allowed') === '1');
  },

  enter(data, cbSuccess, cbFailure) {

    RestClient.disableNonEnterQueries();

    data['mark'] = Entrance.jwtMark();

    //console.log('ajax users/enter');
      $.ajax({
       url  : baseURL + 'users/enter',
       type : 'POST',
       data : JSON.stringify(data),
       beforeSend: function (xhr) {
             xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          //console.log('zz_success');
          //setTimeout(cbSuccess(data), 100);
          cbSuccess(data);

          RestClient.enableNonEnterQueries();
        },
        function(error){
           var data = error.responseJSON;
           var schError = new SCHError();
           schError.setTitle(data['title']);
           schError.setMessage(data['message']);
           schError.setHttpStatus(error.status);
           //setTimeout(cbFailure(schError), 100);
           cbFailure(schError);

           //RestClient.enableNonEnterQueries();
        }
    );
  },

  processError(error) {
    // var data = error.responseJSON;
    // console.log(data);
    // if (data['event_kind'] == 'access_token_expired') {
    //   console.log('silentEnter');
    //     Entrance.silentEnter();
    // }
  },

  getLatestProcess(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'processes/latest',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
      function(data){
        if (Number(data['count']) === 1)
        {
          cbSuccess(data['process']);
        }else {
          cbSuccess(null);
        }
      },
      function(error){
        RestClient.processError(error);
        cbFailure();
      }
    );

    return true;
  },

  pauseLatestProcess(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure();return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'processes/latest/pause',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
             xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){ cbSuccess(data); },
        function(error){ cbFailure(); }
    );

    return true;
  },

  resumeLatestProcess(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure();return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'processes/latest/resume',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
             xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){ cbSuccess(data); },
        function(error){ cbFailure(); }
    );
    return true;
  },

  cancelLatestProcess(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure();return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'processes/latest/cancel',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
             xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){ cbSuccess(data); },
        function(error){ cbFailure(); }
    );
    return true;
  },

  getEvents(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}
    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'events/',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
      function(data){
        if (Number(data['count']) > 0)
        {
          cbSuccess(data['list']);
        }else {
          cbSuccess(null);
        }
      },
      function(error){
        cbFailure();
      }
    );
    return true;
  },

  getAccounts(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'accounts',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          //console.log('data: %o', data);
          cbSuccess(data['list']);
        },
        function(error){
          //console.log('zerrrrror: %o', error);
          //console.log('error: responseText: ' + error.responseText);
          //console.log('processError');
          //RestClient.processError(error);
          cbFailure();
       }
    );

    return true;
  },

  getAccountsCount(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'accounts/count',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data['count']);
        },
        function(error){
          cbFailure();
       }
    );
    return true;
  },

  getAccount(id, cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'accounts/' + id,
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
            console.dir(data);
            localStorage.setItem("id_account",data['id_account']);



            try
            {
                // for V2
                localStorage.setItem("sub",data['creator_subscriptions'][0]['product']['id']);
            }
            catch
            {
                //for V1
                localStorage.setItem("sub",data['subscriptions'][0]['product']['id']);
            }

            //
          cbSuccess(data);
        },
        function(error){
          cbFailure();
       }
    );
    return true;
  },

  scheduleProcess(process_kind_name, account_id, start_timestamp, vars, cbSuccess, cbFailure) {

    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}
    //console.log('scheduleProcess name: '+ process_kind_name);
    var data = {
      'process_kind_name': process_kind_name,
      //due to WSCH.037
      //'account_id':account_id,//<-
      'start_timestamp':start_timestamp,
      'vars':vars,
      'mark': Entrance.jwtMark()
    };

    //$json0->process_kind_name
    //$json0->account_id
    //$json0->start_time
    //$json0->vars //[]?
    $.ajax({
       url: baseURL + 'processes/',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          cbFailure();
       }
    );
    return true;
  },


//$json0->event_kind_name, $json0->title, $json0->message
  logEvent(event_kind_name, title, message, cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = {
      'account_id': Globs.getAccountId(),
      'event_kind_name': event_kind_name,
      'title':title,
      'message':message,
      'mark': Entrance.jwtMark(),
    };

    //$json0->vars //[]?
    $.ajax({
       url: baseURL + 'events/',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          cbFailure();
       }
    );
    return true;
  },

  currentUserInfo(cbSuccess, cbFailure){
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
     url  : baseURL + 'users/me',
     type : 'GET',
     data: data,
     beforeSend: function (xhr) {
           xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
       },
    })
    .then(
        function(data){ setTimeout(cbSuccess(data), 100); },
        function(error){ setTimeout(cbFailure(), 100); }
    );
    return true;
  },

  stats(account_id, cbSuccess, cbFailure){
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
     url  : baseURL + 'accounts/'+account_id+'/stats',
     type : 'GET',
     data: data,
     beforeSend: function (xhr) {
           xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
       },
    })
    .then(
        function(data){  setTimeout(cbSuccess(data), 100); },
        function(error){ setTimeout(cbFailure(), 100); }
    );
    return true;
  },

  linkAccount(login, password, cbSuccess, cbFailure){
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = {
      'login': login,
      'password': password,
      'mark': Entrance.jwtMark()
    };
    $.ajax({
     url  : baseURL + 'users/link_account',
     type : 'POST',
     data : JSON.stringify(data),
     beforeSend: function (xhr) {
           xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
       },
    })
    .then(
        function(data){  setTimeout(cbSuccess(data), 100); },
        function(error){  setTimeout(cbFailure(error.responseJSON), 100); }
    );
    return true;
  },

  switchAccount(account_id, cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = {
      'account_id': account_id,
      'mark': Entrance.jwtMark()
    };
    $.ajax({
       url: baseURL + 'users/switch_account',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          //console.log('error: responseText: ' + error.responseText);
          cbFailure();
       }
    );
    return true;
  },

  getAccountSettings(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'accounts/sets',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
      function(data){
        cbSuccess(data);
      },
      function(error){
        cbFailure();
      }
    );
    return true;
  },

  getUserTimezone(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'users/me/timezone',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
      function(data){
        cbSuccess(data);
      },
      function(error){
        cbFailure();
      }
    );
    return true;
  },

  setUserTimezone(timezone, cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = {
      'tz': timezone,
      'mark': Entrance.jwtMark()
    };
    $.ajax({
       url: baseURL + 'users/me/timezone',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          cbFailure();
       }
    );
    return true;
  },

  purchase(time_product_code, cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}
    var data = {
      'time_product_code': time_product_code,
      'mark': Entrance.jwtMark()
    };
    $.ajax({
       url: baseURL + 'users/me/purchase/',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          //console.log('error: responseText: ' + error.responseText);
          cbFailure();
       }
    );
    return true;
  },

  cancelAutoPay(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}
    // var data = {
    //   'time_product_code': time_product_code,
    // };
    var data = {
      'mark': Entrance.jwtMark()
    };
    $.ajax({
       url: baseURL + 'users/me/cancel_autopay',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          //console.log('error: responseText: ' + error.responseText);
          cbFailure();
       }
    );
    return true;
  },

  getAutoPayStatus(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}
    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'users/me/autopay',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
      function(data){
        cbSuccess(data['autopay']);
      },
      function(error){
        cbFailure();
      }
    );
    return true;
  },

  changePass(newPass, cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = {
      'new_pass': newPass,
      'mark': Entrance.jwtMark()
    };
    $.ajax({
       url: baseURL + 'users/me/change_pass',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          //console.log('error: responseText: ' + error.responseText);
          cbFailure(error.responseJSON);
       }
    );
    return true;
  },

  changePassConfirm(key, cbSuccess, cbFailure) {
    //this enter like query
    //if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = {
      'key': key,
      'mark': Entrance.jwtMark()
    };
    $.ajax({
       url: baseURL + 'users/me/confirm_change_pass',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          //console.log('error: responseText: ' + error.responseText);
          cbFailure(error.responseJSON);
          //setTimeout(cbFailure(error.responseJSON), 100);
       }
    );
    return true;
  },

  forgotPass(email, cbSuccess, cbFailure) {
    //if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}
    //console.log("forgotPass0");
    var data = {
      'email': email
    };
    $.ajax({
       url: baseURL + 'users/me/forgot_pass',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          //console.log("cbSuccess");
          cbSuccess(data);
        },
        function(error){
            //console.log("cbFailure");
            //console.log(error);
          //console.log('zerror: responseText: ' + error.responseText);
          cbFailure(error.responseJSON);
       }
    );
    //console.log("forgotPass1");
    return true;

  },

  forgotPassConfirm(key, email, cbSuccess, cbFailure) {
    var data = {
      'key': key,
      'email': email,
      'mark': Entrance.jwtMark()
    };
    $.ajax({
       url: baseURL + 'users/me/confirm_forgot_pass',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          //console.log('error: responseText: ' + error.responseText);
          cbFailure(error.responseJSON);
          //setTimeout(cbFailure(error.responseJSON), 100);
       }
    );
    return true;
  },


  unlinkAccount(account_id, cbSuccess, cbFailure) {
    //this enter like query
    //if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = {
      'account_id': account_id,
      'mark': Entrance.jwtMark()
    };
    $.ajax({
       url: baseURL + 'users/me/unlink_account',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          //console.log('error: responseText: ' + error.responseText);
          cbFailure(error.responseJSON);
          //setTimeout(cbFailure(error.responseJSON), 100);
       }
    );
    return true;
  },

  getRemovableAccounts(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'users/me/removable_accounts',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          //console.log('data: %o', data);
          cbSuccess(data['list']);
        },
        function(error){
          //console.log('zerrrrror: %o', error);
          //console.log('error: responseText: ' + error.responseText);
          //console.log('processError');
          //RestClient.processError(error);
          cbFailure(error);
       }
    );

    return true;
  },

  getSharedDb(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'users/me/shared_db',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
      function(data){
        cbSuccess(data);
      },
      function(error){
        cbFailure();
      }
    );
    return true;
  },

  switchSharedDb(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = {
      'mark': Entrance.jwtMark()
    };
    $.ajax({
       url: baseURL + 'users/me/switch_shared_db',
       type: 'POST',
       data: JSON.stringify(data),
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
        function(data){
          cbSuccess(data);
        },
        function(error){
          cbFailure();
       }
    );
    return true;
  },

  reAuthCurrentAccount(password, cbSuccess, cbFailure){
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = {
      'password': password,
      'mark': Entrance.jwtMark()
    };
    $.ajax({
     url  : baseURL + 'users/me/re_auth',
     type : 'POST',
     data : JSON.stringify(data),
     beforeSend: function (xhr) {
           xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
       },
    })
    .then(
        function(data){  setTimeout(cbSuccess(data), 100); },
        function(error){  setTimeout(cbFailure(error.responseJSON), 100); }
    );
    return true;
  },

  getPurchaseEndTime(cbSuccess, cbFailure) {
    if (!RestClient.allowedNonEnterQueries()){cbFailure(); return false;}

    var data = { 'mark': Entrance.jwtMark() };
    $.ajax({
       url: baseURL + 'users/me/purchaseEndTime',
       type: 'GET',
       data: data,
       beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + Entrance.accessToken());
         },
    })
    .then(
      function(data){
        cbSuccess(data);
      },
      function(error){
        cbFailure();
      }
    );
    return true;
  },

///

  // switchAccountAndGetToken(account_id, cbSuccess, cbFailure) {
  //
  //   var data = {
  //     'account_id': account_id,
  //   };
  //
  //   $.ajax({
  //      url: baseURL + 'users/switch_account',
  //      type: 'POST',
  //      data: JSON.stringify(data),
  //      beforeSend: function (xhr) {
  //         xhr.setRequestHeader("Authorization", "Bearer " + Auth.accessToken());
  //        },
  //   })
  //   .then(
  //       function(data){
  //         cbSuccess(data['token']);
  //       },
  //       function(error){
  //         //console.log('error: responseText: ' + error.responseText);
  //         cbFailure();
  //      }
  //   );
  // },


}

export default RestClient;
